import { formatBytes } from "./format.ts";

export interface AttachmentView {
  readonly draftId: string;
  readonly name: string;
  readonly kind: "image" | "file";
  readonly size: number;
  readonly status: "uploading" | "ready" | "error";
  readonly error: string | null;
  readonly previewUrl: string | null;
  readonly canRetry: boolean;
}

export function attachmentKindLabel(attachment: Pick<AttachmentView, "kind">): string {
  return attachment.kind === "image" ? "Image" : "Text file";
}

export function attachmentStatusLabel(attachment: Pick<AttachmentView, "status" | "kind">): string {
  if (attachment.status === "uploading") return "Uploading";
  if (attachment.status === "error") return "Not attached";
  return attachment.kind === "image" ? "Ready to send as image input" : "Ready to send";
}

export function attachmentDetailLabel(attachment: Pick<AttachmentView, "kind" | "size" | "status">): string {
  return `${attachmentKindLabel(attachment)} · ${formatBytes(attachment.size)} · ${attachmentStatusLabel(attachment)}`;
}

export function attachmentCountLabel(attachments: readonly Pick<AttachmentView, "kind">[]): string {
  const images = attachments.filter((attachment) => attachment.kind === "image").length;
  const files = attachments.length - images;
  return `${images} ${images === 1 ? "image" : "images"}, ${files} ${files === 1 ? "text file" : "text files"}`;
}

export function attachmentSendBlockedReason(input: {
  readonly pending: boolean;
  readonly failed: number;
  readonly count: number;
}): string | null {
  if (input.pending) return "Wait for the attachment to finish uploading before sending.";
  if (input.failed > 0) return "Remove or retry the failed attachment before sending.";
  return null;
}
